import './AssistantIcon.scss'

interface AssistantIconProps {
    icon?: string
    iconSrc?: string
    alt?: string
    className?: string
    title?: string
}

const AssistantIcon = ({ icon, iconSrc, alt, className = '', title }: AssistantIconProps) => {
    if (icon)
        return <i className={`a-icon boschicon-bosch-ic-${icon} ${className}`} title={title}></i>

    if (iconSrc)
        return <img className={`a-icon custom-icon ${className}`} src={iconSrc} alt={alt} title={title} />

    return null
}

export default AssistantIcon
